import { useAccountEntitlements } from "@/entitlements/queries/useAccountEntitlements";

// Single entitlement gating the CRO product surface. It covers both Session
// Replay (IND-2855) and Heatmaps (IND-2856); both features read this one key.
export const SESSION_REPLAY_HEATMAPS_ENTITLEMENT_KEY =
  "sessionReplayAndHeatmaps";

export function useHasSessionReplayHeatmapsEntitlement(): {
  loading: boolean;
  isError: boolean;
  hasEntitlement: boolean;
} {
  const { data, isLoading, isError } = useAccountEntitlements();

  return {
    loading: isLoading,
    isError,
    hasEntitlement:
      data?.account_access?.some(
        (access) =>
          access.entitlement_key === SESSION_REPLAY_HEATMAPS_ENTITLEMENT_KEY,
      ) ?? false,
  };
}
